import {
  Box,
  Button,
  Input,
  InputGroup,
  InputLeftAddon,
  Select,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineCamera } from "react-icons/ai";
import { ImVideoCamera } from "react-icons/im";
import { useGetState } from "../../context/useGetState";
import TakePhotoVideoModal from "./components/TakePhotoVideoModal";
import { ProfileInputField } from "./ProfileInputField";
import { updateProfile } from "./service";
import http, { AUTH_ROUTES, photoBaseURL } from "../../service/api";
import { errorNotifier, successNotifier } from "../..";

function GetUserVerified({ user = {}, setShowVerificationSumitSuccess }) {
  const containerBgColor = useColorModeValue("#f9fafc", "#020B19");
  const containerBorderColor = useColorModeValue("#e7e7e7", "#020b19");
  const { state } = useGetState();
  const bg1Style = useColorModeValue(
    { background: "#707070", border: "3px solid #E1E1E1" },
    {
      background: "#000000",
      border: "3px solid #676767",
      color: "#fff",
    }
  );
  const [formValues, setFormValues] = useState({});
  const [file, setFile] = useState("");
  
  const [file1, setFile1] = useState("");
  const [file2, setFile2] = useState("");

  const btnStyle = useColorModeValue(
    { bg: "#1392E6" },
    {
      bg: "#0076FF",
    }
  );
  const textColor2 = useColorModeValue("#000", "#636363");

  const [loading, setLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+234");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((initial) => ({ ...initial, [name]: value }));
  };

  //form validation
  useEffect(() => {
    const { profession } = formValues;
    if (!profession || !phoneNumber) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [formValues, file]);

  const handleSubmit = async () => {

    if(file1 && file2) {
      const formData2 = new FormData();
      formData2.append("file1", file1);
      formData2.append("file2", file2);
      const fileRes = http.post(AUTH_ROUTES.USER_VERIFICATION2, formData2)
      console.log('file: ', fileRes);
    }

    const formData1 = new FormData();
    formData1.append("name", state?.userInfo?.name);
    formData1.append("profession", formValues?.profession);
    formData1.append("phone", `${countryCode}${phoneNumber}`);
    formValues?.article1 && formData1.append("article1", formValues?.article1);
    formValues?.article2 && formData1.append("article2", formValues?.article2);

    //formData.append("file", file);
    setLoading(true);
    // photoBaseURL
    http
      .post(AUTH_ROUTES.USER_VERIFICATION1, formData1)
      .then((res) => {

        setLoading(false);
        setShowVerificationSumitSuccess(true);
      })
      .catch((e) => {
        errorNotifier(e?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <Box
      width="100%"
      border={`1px solid ${containerBorderColor}`}
      p="30px 40px 15px 40px"
      borderRadius={"10px"}
      textAlign="left"
      bg={containerBgColor}
      color="#343434"
      maxW={"650px"}
    >
      <Stack
        mb="20px"
        direction={["column", "column", "column", "row"]}
        alignItems={["center", "center", "center", "flex-start"]}
        justifyContent={"center"}
      >
        <Box maxW="400px">
          <ProfileInputField
            type2
            name={"name"}
            value={state?.userInfo?.name}
            label={"Full Name"}
            type="text"
          />
          <ProfileInputField
            type2
            name={"profession"}
            value={formValues?.profession}
            label={"Profession"}
            type="text"
            handleChange={handleChange}
          />

          <ProfileInputField
            type3
            name={"phone"}
            value={phoneNumber}
            label={"Phone Number"}
            type="tel"
            handleChange={(e) => setPhoneNumber(e.target.value)}
            setCountryCode={setCountryCode}
          />
          <ProfileInputField
            type2
            name={"article1"}
            value={formValues?.article1}
            placeholder="Link to an article About you"
            label={"Article 1 (Optional)"}
            type="link"
            handleChange={handleChange}
          />
          <ProfileInputField
            type2
            name={"article2"}
            value={formValues?.article2}
            placeholder="Link to an article About you"
            label={"Article 2 (Optional)"}
            type="link"
            handleChange={handleChange}
          />
          <Stack
            direction={"row"}
            alignItems="center"
            justifyContent={"center"}
          >
            <TakePhotoVideoModal
              openModal={openModal}
              close={() => setOpenModal({ open: false, type: "" })}
              onFinish={(file) => {
                file?.name === "user_image.jpg" && setFile1(file);
                file?.name === "my-video.webmg" && setFile2(file);
                setOpenModal({ open: false, type: "" });
              }}
            />
            {/* camera icon */}
            <Stack
              onClick={() => setOpenModal({ open: true, type: "photo" })}
              cursor={"pointer"}
              direction={"row"}
              alignItems="center"
              color="#fff"
              bg="#008133"
              borderRadius={"5px"}
              p="2px 20px 2px 10px"
            >
              <AiOutlineCamera fontSize={"1.7em"} />

              <Text fontSize={".9em"}>Take Selfie</Text>
            </Stack>

            {/* video icon */}
            <Stack
              onClick={() => setOpenModal({ open: true, type: "video" })}
              cursor={"pointer"}
              direction={"row"}
              alignItems="center"
              color="#fff"
              bg="#00157E"
              borderRadius={"5px"}
              p="2px 20px 2px 10px"
            >
              <ImVideoCamera fontSize={"1.7em"} />

              <Text fontSize={".9em"}>Make a Video</Text>
            </Stack>

          </Stack>
          <Stack>
            <Text
              textAlign={"center"}
              mt="10px"
              fontSize={".8em"}
              fontStyle={"italic"}
              color="blue"
              fontWeight={"bold"}
            >
              {file?.name}
            </Text>
          </Stack>

          <Text
            color={textColor2}
            textAlign={"center"}
            my="20px"
            fontSize={".7em"}
            mx="-400px"
          >
            For faster verification please be sure to provide your social media
            usernames at the profile overview
            <br /> as it will also be verified.
          </Text>
          <Stack alignItems={"center"} mt="10px">
            <Button
              justifySelf={"center"}
              height="35px"
              disabled={disabled}
              {...btnStyle}
              color="#fff"
              width="320px"
              borderRadius={"7px"}
              isLoading={loading}
              onClick={handleSubmit}
              fontSize="1em"
              fontWeight={"500"}
            >
              submit
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}

export default GetUserVerified;
